import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  // ========== Public Routes (no auth required) ==========
  {
    path: 'review/:token',
    loadComponent: () =>
      import('./features/review/review.component').then((m) => m.ReviewComponent),
  },
  {
    path: 'confirmation/:token',
    loadComponent: () =>
      import('./features/confirmation/confirmation.component').then(
        (m) => m.ConfirmationComponent
      ),
  },
  {
    path: 'expired',
    loadComponent: () =>
      import('./features/expired/expired.component').then((m) => m.ExpiredComponent),
  },

  // ========== Admin Routes (Keycloak auth required) ==========
  {
    path: 'admin/yearbooks/:yearbookId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/admin-dashboard/admin-dashboard.component').then(
        (m) => m.AdminDashboardComponent
      ),
  },
  {
    path: 'admin/yearbooks/:yearbookId/upload',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/guts-upload/guts-upload.component').then((m) => m.GutsUploadComponent),
  },

  // ========== Fallback ==========
  { path: '', redirectTo: 'expired', pathMatch: 'full' },
  { path: '**', redirectTo: 'expired' },
];
